// extracted by mini-css-extract-plugin
export default {"header":"Header_header__C8dJc","menu":"Header_menu__1r0Eq","searchContainer":"Header_searchContainer__UbqFV","searchImage":"Header_searchImage__D9M6n"};